<template>
  <span class="log-link">
    <template v-if="isImageLink">
      <a :href="url" target="_blank" class="image-link"><img :src="url"/></a>
    </template>
    <template v-else>
      <a :href="url" target="_blank">{{link}}</a>
    </template>
  </span>
</template>

<script>
export default {
  name: 'LogLink',
  props: {
    url: String
  },
  data () {
    return {
      imageType: ['.jpg', '.jpeg', '.png', '.gif', '.bmp']
    }
  },
  computed: {
    link: function () {
      let defaultNode = this.$slots.default
      if (defaultNode && defaultNode.length > 0) {
        return defaultNode[0].text
      }
      return ''
    },
    isImageLink: function () {
      let link = this.link
      if (link) {
        let index = link.lastIndexOf('.')
        if (index > 0) {
          let suffix = link.substring(index).toLowerCase()
          return this.imageType.includes(suffix)
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss">
.log-link {
  a {
    text-decoration: none;
    &.image-link {
      display: inline-block;
      position: relative;
      width: 60px;
      height: 60px;
      img {
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
}
</style>
